module.exports = __webpack_public_path__ + "img/person-kol.e0c75946.svg";